import { type FC } from 'react'

import { IconInfo } from '@redteclab/icons'

import { ProductHeadGenericLabel } from '../../../../../../product'
import {
  ProductPrescriptionDrawer,
  useProductPrescriptionDrawerControls,
} from '../../../../ProductPrescriptionDrawer'
import { type ProductHeadLabel } from '../../ProductHeadLabelsTypes'

export const ProductHeadPrescriptionRequiredLabel: FC<{
  label: ProductHeadLabel
}> = ({ label }) => {
  const drawerControls = useProductPrescriptionDrawerControls()

  return (
    <div>
      <ProductHeadGenericLabel
        className="border-dark-brand bg-light-secondary-medium capitalize"
        hasBorder={false}
        onClick={drawerControls.handleOpen}
        type="button"
      >
        {label.labelText}
        <IconInfo className="ml-2 size-4" />
      </ProductHeadGenericLabel>
      <ProductPrescriptionDrawer controls={drawerControls} />
    </div>
  )
}
